const MuiTextField = {
  // margin: 'dense',
  InputLabelProps: {
    shrink: true
  }
};
export default MuiTextField;